import { ArrowDown, MessageCircle } from "lucide-react";

const HERO_BG =
    "https://images.unsplash.com/photo-1775323017119-968d75624046?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjb25jcmV0ZSUyMGFyY2hpdGVjdHVyZSUyMGVuZ2luZWVyaW5nfGVufDB8fHx8MTc3NzQwNjQwOXww&ixlib=rb-4.1.0&q=85";

const WA_LINK = "https://wa.me/543704504444?text=" + encodeURIComponent("Hola RAMSOL, quisiera consultar por un proyecto.");

export default function Hero() {
    return (
        <section id="top" className="relative min-h-[100svh] flex items-end overflow-hidden" data-testid="hero-section">
            <div
                className="absolute inset-0"
                style={{
                    backgroundImage: `url(${HERO_BG})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/80 to-[#0A0A0A]/40" />
            <div className="absolute inset-0 grain pointer-events-none opacity-40" />

            <div className="relative max-w-7xl mx-auto px-6 md:px-12 w-full pb-20 md:pb-28 pt-32">
                <p className="overline fade-up" data-testid="hero-overline">Since 2017</p>

                <h1 className="hero-headline mt-6 text-5xl sm:text-6xl md:text-7xl lg:text-[8rem] fade-up fade-up-delay-1" data-testid="hero-headline">
                    Construimos
                    <br />
                    <span className="accent">soluciones</span> sólidas.
                </h1>

                <div className="mt-10 max-w-xl fade-up fade-up-delay-2">
                    <p className="text-base md:text-lg text-white/70 leading-relaxed">
                        Ejecutamos obras civiles, mantenimiento industrial e instalaciones de alto rendimiento.
                    </p>
                </div>

                <div className="mt-10 flex flex-wrap items-center gap-4 fade-up fade-up-delay-3">
                    <a
                        href={WA_LINK}
                        target="_blank"
                        rel="noreferrer"
                        className="btn-primary"
                        data-testid="hero-whatsapp-btn"
                    >
                        <MessageCircle size={16} />
                        Hablar por WhatsApp
                    </a>
                    <a href="#servicios" className="btn-ghost" data-testid="hero-servicios-btn">
                        Ver servicios
                        <ArrowDown size={16} />
                    </a>
                </div>

                {/* Stats strip */}
                <div className="mt-16 md:mt-24 grid grid-cols-3 gap-6 md:gap-12 max-w-3xl fade-up fade-up-delay-4">
                    {[
                        { k: "+9", l: "Años de experiencia" },
                        { k: "+80", l: "Obras ejecutadas" },
                        { k: "+12.560", l: "m² construidos" },
                    ].map((s, i) => (
                        <div key={i} className="border-l border-white/15 pl-4 md:pl-6" data-testid={`hero-stat-${i}`}>
                            <p className="text-3xl md:text-5xl font-black text-white" style={{ fontFamily: "Chivo" }}>
                                {s.k}
                            </p>
                            <p className="text-[10px] md:text-xs uppercase tracking-[0.2em] text-white/60 mt-2">{s.l}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* scroll indicator */}
            <div className="absolute bottom-6 right-6 hidden md:flex items-center gap-3 text-white/50 text-xs uppercase tracking-[0.25em]">
                <span>Scroll</span>
                <span className="w-12 h-px bg-white/30" />
            </div>
        </section>
    );
}
